import { httpClient } from './httpClient';
import type {
  ActiveProviderSubscription,
  CreateSubscriptionCheckoutResponse,
  GetSubscriptionCheckoutStatusResponse,
  GetSubscriptionInvoiceResponse,
} from './types';

interface QueryOptions {
  signal?: AbortSignal;
  timeoutMs?: number;
}

const CREATE_CHECKOUT_TIMEOUT_MS = 20_000;

export const subscriptionApi = {
  getActive: async (options?: QueryOptions): Promise<ActiveProviderSubscription | null> => {
    const subscription = await httpClient.get<ActiveProviderSubscription | undefined>(
      '/api/v1/provider-subscriptions/get-active',
      options
    );
    return subscription ?? null;
  },

  createCheckout: (): Promise<CreateSubscriptionCheckoutResponse> => {
    return httpClient.post<CreateSubscriptionCheckoutResponse>(
      '/api/v1/billing/checkouts',
      undefined,
      { timeoutMs: CREATE_CHECKOUT_TIMEOUT_MS }
    );
  },

  getInvoice: async (
    checkoutId: string,
    options?: QueryOptions
  ): Promise<GetSubscriptionInvoiceResponse | null> => {
    const invoice = await httpClient.get<GetSubscriptionInvoiceResponse | undefined>(
      `/api/v1/billing/checkouts/${checkoutId}/invoice`,
      options
    );
    return invoice ?? null;
  },

  getCheckoutStatus: (
    checkoutId: string,
    options?: QueryOptions
  ): Promise<GetSubscriptionCheckoutStatusResponse> => {
    return httpClient.get<GetSubscriptionCheckoutStatusResponse>(
      `/api/v1/billing/checkouts/${checkoutId}/status`,
      options
    );
  },
} as const;
